<template>
  <div>
    <div v-for="(r,i) in records" v-if="isRecordActive(r)" class="mb-1">
      <div class="input-group">
        <div class="input-group-prepend">
          <select :disabled="disableToEdit" v-model="r.int_value"
                  :class="{'form-control': true, not_selected: !r.int_value}">
            <option value="0" disabled>Выберите страну</option>
            <option v-for="c in $AllCountries" v-if="c.is_active" :value="c.id">{{ c.name }}</option>
          </select>
        </div>
        <template v-for="d in defaultDimensions">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ d.abr }}</span>
          </div>
          <input type="number" :disabled="disableToEdit" :placeholder="d.title"
                 :aria-label="d.title"
                 class="form-control" v-model="r.array_value[d.alias]">
        </template>
        <div class="input-group-prepend">
          <button @click="removeDetail(i)" class="btn btn-outline-danger" type="button" :disabled="disableToEdit">
            <i class="icon-fa icon-fa-trash"/>
          </button>
        </div>
      </div>
      <div class="input-group">
        <input type="text" :disabled="disableToEdit" placeholder="комментарий" v-model="r.array_value.comment"
               class="form-control">
        <div class="input-group-append">
          <span class="input-group-text">{{ printDate(r.created_at, 'DD.MM.YYYY')}}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-jc-between">
      <button v-if="!disableToEdit" type="button" class="btn btn-outline-info btn-xs" @click="addNewRecord">добавить
        запись
      </button>
      <LoadingButton
        v-if="updateRecords"
        title="сохранить"
        type="button"
        className="btn btn-outline-success btn-xs"
        :onClick="() => saveRecords()"
        :loading="btnLoading"
        :color="$constants.SUCCESS_COLOR"
      />
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['records', 'drugId', 'disableToEdit', 'countryId', 'updateRecords', 'onSave', 'addEmpty'],
  data() {
    return {
      btnLoading: false,
      defaultDimensions: [
        {alias: 'depth', title: 'длина', abr: 'Д'},
        {alias: 'width', title: 'ширина', abr: 'Ш'},
        {alias: 'height', title: 'высота', abr: 'В'},
        {alias: 'weight', title: 'вес', abr: 'Вс'},
      ]
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries']
    },
  },
  created() {
    if (!(this.records ?? []).length || this.addEmpty) this.addNewRecord();
  },
  methods: {
    async saveRecords() {
      const details = this.getDetails();
      if (!details.length) return;
      this.btnLoading = true;
      const {data} = await api.post('/new/drugs/details', {
        type: 'array',
        drug_id: this.drugId,
        details
      });
      if (data.success) {
        if (this.onSave) await this.onSave();
        toastr['success']('Сохранено', 'Успешно');
      }
      this.btnLoading = false;
    },
    getDetails() {
      return this.records.filter(r => r.group_alias === 'country_data' && r.alias === 'dimensions')
        .filter((r) => r.id || !r.id && !r.to_delete)
        .filter((r) => r.int_value && !this.defaultDimensions.find((d) => !r.array_value[d.alias]));
    },
    removeDetail(i) {
      this.$set(this.records[i], 'to_delete', true);
    },
    addNewRecord() {
      this.records.push({
        group_alias: 'country_data',
        drug_id: this.drugId,
        alias: 'dimensions',
        type: "array",
        int_value: this.countryId ?? 0,
        to_delete: false,
        array_value: this.defaultDimensions.reduce((acc, o) => {
          acc[o.alias] = null;
          return acc;
        }, {comment: null})
      })
    },
    isRecordActive(record) {
      // if (this.countryId && +record.int_value !== this.countryId) return false;
      return !record.to_delete && record.group_alias === 'country_data' && record.alias === 'dimensions';
    }
  }
}

</script>

<style scoped>
select.form-control {
  -webkit-appearance: menulist-button;
  color: black;
}

select.form-control.not_selected {
  color: red;
}
</style>
